const ClipboardIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 3H15C15.5523 3 16 3.44772 16 4V5H8V4C8 3.44772 8.44772 3 9 3Z" stroke="white" strokeWidth="2"/>
    <rect x="5" y="5" width="14" height="16" rx="2" stroke="white" strokeWidth="2"/>
    <path d="M9 12H15M9 16H13" stroke="white" strokeWidth="2" strokeLinecap="round"/>
  </svg>
)

export default ClipboardIcon
